module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_3009.0c87007a.png";